import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import NewSaasPlanModal from './components/NewSaasPlanModal';
import CheckoutModal from './components/CheckoutModal';
import { PlusIcon } from '@stash-ui/regular-icons';

import { Add as AddIcon, Edit as EditIcon, HighlightOff } from '@material-ui/icons';

import { getSaasPlans } from '../../services/saasplans';
import { createSaasPlans, updateSaasFeatureLimits, deleteSaasPlans, getSaasPlan } from '../../services/saasplans';

import { showAlert } from '../../store/ducks/alert';

import CloseIcon from '@material-ui/icons/Close';
import { CircularProgress, Button, IconButton, Checkbox } from '@material-ui/core';

const SaasPlans = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [saasplans, setSaasPlans] = useState([]);
  const [formattedSaasPlans, setFormattedSaasPlans] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [formData, setFormData] = useState({});
  const [page, setPage] = useState(0);

  const [remove, setRemove] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  const [isNewSaasPlanModalOpen, setIsNewSaasPlanModalOpen] = useState(false);
  const [isCheckoutModalOpen, setIsCheckoutModalOpen] = useState(false);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayChannels(currentPage);
  }, [isSearching, isOrdering, page]);

  useEffect(() => {
    const newArray = saasplans?.map(saasplan => {
      return {
        select: (
          <Checkbox
            color="default"
            value={saasplan.id}
            onChange={() => handleSelectedPlan(saasplan)}
            checked={renderCheckedPlans(saasplan.id)}
          />
        ),
        ...saasplan,
      };
    });

    setFormattedSaasPlans(newArray);
  }, [saasplans, selectedPlans]);

  const renderCheckedPlans = id => {
    return selectedPlans.some(plan => plan.id === id);
  };

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const handleCloseModal = () => {
    setFormData({});
    setIsNewSaasPlanModalOpen(false);
  };

  const handleCloseRemoveAlert = () => {
    setRemove(false);
  };
  const handleSubmitDelete = async () => {
    try {
      await deleteSaasPlans(formData.id);
      dispatch(showAlert('success', 'Subscription canceled!'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not cancel this subcription. 😔'));
    }
  };

  const customActions = [
    {
      icon: <HighlightOff />,
      action: item => {
        setFormData(item);
        setRemove(true);
      },
    },
    {
      icon: <EditIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
  ];

  const handleOpenUpdate = async item => {
    if (item.enabled === '⛔️ Não') item.enabled = 'false';
    if (item.enabled === '✅ Sim') item.enabled = 'true';
    const { data } = await getSaasPlan(item.id);
    setIsUpdating(true);
    const { name, periodOfMonths, type, value, SaasFeatureLimit, tier } = data?.saasPlan;
    const limits = {
      contacts: SaasFeatureLimit?.contacts,
      emailSends: SaasFeatureLimit?.emailSends,
      magIA: SaasFeatureLimit?.magIA,
      segmentation: SaasFeatureLimit?.segmentation,
      workflow: SaasFeatureLimit?.workflow,
      customTemplateEmail: SaasFeatureLimit?.customTemplateEmail,
      dailyEmailSends: SaasFeatureLimit?.dailyEmailSends,
      aiCredits: SaasFeatureLimit?.aiCredits,
      publicApi: SaasFeatureLimit?.publicApi,
      workflowWebhook: SaasFeatureLimit?.workflowWebhook,
      whatsAppNumbers: SaasFeatureLimit?.whatsAppNumbers,
      channelMembers: SaasFeatureLimit?.channelMembers,
      shortLinkDomains: SaasFeatureLimit?.shortLinkDomains,
      shortLinks: SaasFeatureLimit?.shortLinks,
    };
    setFormData({ id: item.SaasFeatureLimitId, name, periodOfMonths, type, value, tier, ...limits });
    setIsNewSaasPlanModalOpen(true);
  };

  const handleSubmitForm = async dataForm => {
    try {
      const {
        name,
        value,
        periodOfMonths,
        tier,
        type,
        emailSends,
        contacts,
        segmentation,
        customTemplateEmail,
        magIA,
        workflow,
        dailyEmailSends,
        aiCredits,
        publicApi,
        workflowWebhook,
        whatsAppNumbers,
        channelMembers,
        shortLinkDomains,
        shortLinks,
      } = dataForm;

      const saasLimit = [
        { feature: 'emailSends', value: Number(emailSends) },
        { feature: 'contacts', value: Number(contacts) },
        { feature: 'segmentation', value: Number(segmentation) },
        { feature: 'customTemplateEmail', value: Number(customTemplateEmail) },
        { feature: 'magIA', value: Number(magIA) },
        { feature: 'workflow', value: Number(workflow) },
        { feature: 'dailyEmailSends', value: Number(dailyEmailSends) },
        { feature: 'aiCredits', value: Number(aiCredits) },
        { feature: 'publicApi', value: Number(publicApi) },
        { feature: 'workflowWebhook', value: Number(workflowWebhook) },
        { feature: 'whatsAppNumbers', value: Number(whatsAppNumbers) },
        { feature: 'channelMembers', value: Number(channelMembers) },
        { feature: 'shortLinkDomains', value: Number(shortLinkDomains) },
        { feature: 'shortLinks', value: Number(shortLinks) },
      ];

      if (!isUpdating) {
        await createSaasPlans({
          name,
          value,
          periodOfMonths,
          tier: tier === 'null' ? null : tier,
          type,
          limits: saasLimit,
        });
      } else {
        await updateSaasFeatureLimits(dataForm.id, {
          emailSends: Number(emailSends),
          contacts: Number(contacts),
          segmentation: Number(segmentation),
          customTemplateEmail: Number(customTemplateEmail),
          magIA: Number(magIA),
          workflow: Number(workflow),
          dailyEmailSends: Number(dailyEmailSends),
          aiCredits: Number(aiCredits),
          publicApi: Number(publicApi),
          workflowWebhook: Number(workflowWebhook),
          whatsAppNumbers: Number(whatsAppNumbers),
          channelMembers: Number(channelMembers),
          shortLinkDomains: Number(shortLinkDomains),
          shortLinks: Number(shortLinks),
        });
      }

      setIsUpdating(false);

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/saasPlans';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const headers = [
    'select',
    'id',
    'name',
    'value',
    'country',
    'enabled',
    'type',
    'periodOfMonths',
    'createdAt',
    'updatedAt',
    'deletedAt',
    'SaasFeatureLimitId',
  ];

  const SearchBoxHeaders = ['id', 'name', 'country', 'type', 'periodOfMonths', 'SaasFeatureLimitId'];

  const handleSelectedPlan = selectedplan => {
    if (selectedPlans.length === 0) {
      setSelectedPlans([selectedplan]);
    } else {
      selectedPlans?.map(plan => {
        if (plan.id === selectedplan.id) {
          setSelectedPlans(selectedPlans.filter(item => item.id !== selectedplan.id));
        } else {
          setSelectedPlans([...selectedPlans, selectedplan]);
        }
      });
    }
  };

  const displayChannels = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: saasplans } = await getSaasPlans(currentPage || page, params);

      setSaasPlans(saasplans.rows);
      setTotalItems(saasplans.count);
      setTotalPages(saasplans.pages);
      setPage(saasplans.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>SaasPlans ({totalItems})</h1>
        <Button onClick={() => setIsNewSaasPlanModalOpen(true)} variant="contained" className="modal-btn">
          New SaasPlan
          <PlusIcon />
        </Button>
        <Button onClick={() => setIsCheckoutModalOpen(true)} variant="contained" className="modal-btn" disabled={!selectedPlans.length}>
          {`(${selectedPlans.length})`} Add to Checkout
        </Button>
        <NewSaasPlanModal
          isOpen={isNewSaasPlanModalOpen}
          onClose={() => handleCloseModal()}
          onSubmit={handleSubmitForm}
          isUpdating={isUpdating}
          dataForm={formData}
        />
        <CheckoutModal
          isOpen={isCheckoutModalOpen}
          onClose={() => setIsCheckoutModalOpen(false)}
          selectedItems={selectedPlans}
          onClearSelection={() => setSelectedPlans([])}
          onRemoveItem={item => setSelectedPlans(selectedPlans.filter(plan => plan.id !== item.id))}
        />
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={formattedSaasPlans}
        customActions={customActions}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
      {remove ? (
        <div className="unsubscribe-container">
          <div className="unsubscribe-container-top">
            <h2>Are you sure you want to delete this saas?</h2>

            <IconButton onClick={handleCloseRemoveAlert}>
              <CloseIcon />
            </IconButton>
          </div>
          <div>
            <h4>{formData.id}</h4>
          </div>
          <Button onClick={handleSubmitDelete} variant="contained" className="modal-btn">
            Yes
          </Button>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
export default SaasPlans;
